import { ScopeOption } from '../types';

/**
 * Варианты скоупов для модуля «Создание пользователей» (create_account)
 */
export const createAccountScopes: Record<string, ScopeOption[]> = {
  // Создание пользователей (булево право)
  'users.create': [
    {
      value: 'true',
      label: 'Разрешено',
      description: 'Оператор может создавать новые учётные записи',
      badgeColor: '#10b981'
    },
    {
      value: 'none',
      label: 'Запрещено',
      description: 'Создание пользователей недоступно',
      badgeColor: '#ef4444'
    }
  ],

  // Выбор роли при создании пользователя
  'users.create_role_scope': [
    {
      value: 'all',
      label: 'Все роли системы',
      description: 'Любая роль ниже ранга оператора (ранг 100 - любая роль)',
      badgeColor: '#10b981'
    },
    {
      value: 'below_my_role',
      label: 'Только ниже моей роли',
      description: 'Только роли строго ниже ранга оператора',
      badgeColor: '#3b82f6'
    },
    {
      value: 'specific_roles',
      label: 'Только определённые роли',
      description: 'Выбрать конкретные роли из списка (настраивается ниже)',
      badgeColor: '#8b5cf6'
    },
    {
      value: 'none',
      label: 'Запрещено',
      description: 'Нельзя выбирать роль при создании',
      badgeColor: '#ef4444'
    }
  ]
};
